import { Badge, Box, Button, DrawerBody, DrawerFooter, FormControl, FormHelperText, FormLabel, Icon, Input, Stack, Switch, useToast } from "@chakra-ui/react";
import SearchSelect from "components/select/SearchSelect";
import BroadcastSelection from "components/broadcastSelection/broadcastSelection";
import ContentSelection from "components/contentSelection/contentSelection";
import { AuthContext } from "contexts/AuthContext";
import { useBroadcast } from "hooks/useBroadcast";
import { useContent } from "hooks/useContent";
import ResolutionPicker from "components/resolution/ResolutionPicker";
import { useGroup } from "hooks/useGroup";
import { useLocation } from "hooks/useLocation";
import { create, save } from "lib/firebase";
import moment from "moment";
import { useContext, useEffect, useState } from "react";
import { ChromePicker } from "react-color";
import { MdDone, MdWarningAmber } from "react-icons/md";

export default function GroupForm({ group, onChange }) {
  const { user } = useContext(AuthContext)

  const [data, setData] = useState(group || {
    name: '',
    broadcastId: null,
    broadcast: {
      name: '',
      type: 'regular'
    },
    layoutColor: null,
  })
  const [pickColor, setPickColor] = useState(false)

  const [broadcasts] = useBroadcast({user})
  const [allContent] = useContent({user})

  useEffect(() => {
    onChange(data)
  }, [data])

  return (
    <>
      <Stack direction='column' spacing={4}>
        <FormControl>
          <FormLabel>ID</FormLabel>
          <Input type='text' defaultValue={data.id || 'ID will be auto-generated'} disabled />
        </FormControl>
        <FormControl>
          <FormLabel>Name</FormLabel>
          <Input type='text' value={data.name} onChange={e => setData({...data, name: e.target.value })} />
        </FormControl>
        <FormControl>
          <FormLabel>Layout name</FormLabel>
          <Input type='text' value={data.layoutName} onChange={e => setData({...data, layoutName: e.target.value })} />
        </FormControl>
        <FormControl>
          <FormLabel>Layout color</FormLabel>
          <Stack direction='row' spacing={2}>
            <Badge w={12} backgroundColor={data.layoutColor || '#eaeaea'}></Badge>
            <Input type='text' value={data.layoutColor || 'None'} onClick={() => setPickColor(true)} onChange={() => {}} />
          </Stack>
          { pickColor && <Box position='absolute' zIndex={2} mt={2}>
            <Box position='fixed' top={0} right={0} bottom={0} left={0} onClick={() => setPickColor(false)}/>
            <ChromePicker color={data.layoutColor || '#000'} onChange={col => setData({...data, layoutColor: col.hex })} />
          </Box> }
        </FormControl>
        <FormControl>
          <FormLabel>News provider URL</FormLabel>
          <Input type='text' value={data.newsProviderUrl} onChange={e => setData({...data, newsProviderUrl: e.target.value })} />
        </FormControl>
        <FormControl>
          <FormLabel>Source broadcast</FormLabel>
          <SearchSelect placeholder='Select broadcast'
            pinned={[
              { value: 'new-regular-broadcast', label: 'New regular broadcast' },
              { value: 'new-composite-broadcast', label: 'New composite broadcast' },
            ]}
            options={broadcasts.map(b => ({ value: b.id, label: b.name, hint: b.broadcastList ? 'composite' : undefined }))}
            value={data.broadcastId}
            onChange={broadcastId => setData({...data, broadcastId})} />
        </FormControl>
        {data.broadcastId?.startsWith('new') && (
          <Stack direction='column' spacing={4}>
            <FormControl>
              <FormLabel>Name</FormLabel>
              <Input type='text' value={data.broadcast.name} onChange={e => setData({...data, broadcast: {...data.broadcast, name: e.target.value }})} />
            </FormControl>
            {data.broadcastId === 'new-regular-broadcast' && (
              <>
                <FormControl>
                  <FormLabel>Resolutions</FormLabel>
                  <ResolutionPicker value={data.broadcast.resolutions} content={allContent} onChange={resolutions => setData({...data, broadcast: {...data.broadcast, resolutions }})} />
                </FormControl>
                <ContentSelection resolutions={data.broadcast.resolutions} selected={data.broadcast.contentList || []} onChange={({items, duration}) => setData(current => ({...current, broadcast: {...current.broadcast, type: 'regular', duration: duration, contentList: items, broadcastList: null }}))} />
              </>
            )}
            {data.broadcastId === 'new-composite-broadcast' && (
              <BroadcastSelection selected={data.broadcast.broadcastList || []} onChange={({items, duration}) => setData({...data, broadcast: {...data.broadcast, type: 'composite', duration: duration, broadcastList: items, contentList: null }})} />
            )}
          </Stack>
        )}
      </Stack>
    </>
  );
}